import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <img 
          src="/uploads/hero.jpg" 
          alt="Latest updates in pop culture, politics, and social media" 
          className="hero-image" 
        />
        <p className="eyebrow">Killmoe Newz · Your Source for Trending News</p>
        <h1>Stay Informed. Stay Entertained.</h1>
        <p className="lede">
          Discover the latest updates in pop culture, politics, and social media. Join us for insightful articles, engaging stories, and everything you need to know to stay ahead of the curve.
        </p>
        <div className="cta-row">
          <a href="/latest" className="primary">
            Explore the Latest
          </a>
          <a href="/about" className="secondary">
            Learn More About Us
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Breaking News</h2>
          <p>
            Get real-time updates on the most important stories shaping our world today. Never miss a beat with our comprehensive coverage.
          </p>
        </article>
        <article>
          <h2>Pop Culture Buzz</h2>
          <p>
            Dive into the latest trends, celebrity news, and entertainment highlights. Stay connected with what’s hot in the world of pop culture.
          </p>
        </article>
        <article>
          <h2>Social Media Insights</h2>
          <p>
            Explore the impact of social media on our lives and society. We bring you the latest discussions, trends, and viral moments.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;